import React, { useContext, useState } from 'react'
import { Message } from 'primereact/message'
import { useInputValue } from '../../hooks/useInputValue'
import { AuthService } from '../../services/Auth'
import { Context } from '../../Context'
import { GLOBALS } from '../../utils/Globals'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Link from '@material-ui/core/Link'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import bckimage from '../../utils/images/bckg.jpg'
import { Redirect } from 'react-router-dom'

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {' '}
      {'Copyright © '}
      <Link color="inherit" href="https://www.netmask.co/">
        {' '}
        Netmask{' '}
      </Link>{' '}
      {new Date().getFullYear()} {'.'}{' '}
    </Typography>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${bckimage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'main' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.dark,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const Login = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const { activateAuth } = useContext(Context)

  const { handleReset: handleResetEmail, ...email } = useInputValue({
    value: '',
    name: 'email',
    type: 'text',
    //required: 'required',
    disabled: loading,
  })

  const { handleReset: handleResetPassword, ...password } = useInputValue({
    value: '',
    name: 'password',
    //required: 'required',
    disabled: loading,
    type: 'password',
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const data = {
        email: email.value,
        password: password.value,
      }

      const response = await AuthService.login(data)

      handleResetEmail()
      handleResetPassword()
      setError(null)
      setLoading(false)

      activateAuth(response.access_token.token, response.user)
      return <Redirect to={GLOBALS.menu.dashboard.link} />
    } catch (e) {
      const errors = e.message.split(',').join(' / ')
      setError(errors)
      setLoading(false)
    }
  }

  const classes = useStyles()
  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />{' '}
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>{' '}
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>{' '}
          <form onSubmit={handleSubmit} disabled={loading} className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              {...email}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              {...password}
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            {error && <Message severity="error" text={error}></Message>}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              label={loading ? 'Cargando...' : 'Ingresar'}
            >
              Sign In{' '}
            </Button>{' '}
            {/*             <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  Forgot password ?
                </Link>{' '}
              </Grid>{' '}
              <Grid item>
                <Link href="#" variant="body2">
                  {' '}
                  {"Don't have an account? Sign Up"}{' '}
                </Link>{' '}
              </Grid>{' '}
            </Grid>{' '} */}
            <Box mt={5}>
              <Copyright />
            </Box>{' '}
          </form>{' '}
        </div>{' '}
      </Grid>{' '}
    </Grid>
  )
}

export default Login
